import WithdrawalDataComponent from './WithdrawalDataComponent.container'
export default WithdrawalDataComponent
